import { type RouteObject } from 'react-router-dom';

import { GUIDE_PATH } from '../features/knowledge-base/utils/guideUrls';

// Public siblings of the authenticated routes; shared providers supply the app theme and store.
// `/kb/:topic` alone serves bookmarks from before topic-qualified URLs (a bare
// article ID or an encoded `topic%2Fid`); the page resolves and canonicalizes them.
export const knowledgeBaseRoutes: RouteObject[] = [
  GUIDE_PATH,
  `${GUIDE_PATH}/:topic`,
  `${GUIDE_PATH}/:topic/:id`,
].map(path => ({
  path,
  async lazy() {
    const { KnowledgeBasePage } = await import('@features/knowledge-base');
    return { Component: KnowledgeBasePage };
  },
}));
